/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconPineTree: {
  name: 'pine_tree';
  data: string;
} = {
  name: 'pine_tree',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m436.407 403.52 34.761.357-52.346-58.994 33.993-24.373c-55.368-43.532-70.316-65.216-83.732-108.751l45.048 20.43-55.809-75.093 30.682-10.349c-51.899-41.01-77.254-82.35-91.03-123.834l-.002.298c-21.653 46.18-53.868 86.494-92.86 123.043l45.082-4.715-61.367 77.76 29.641-9.47-40.163 65.617 19.745 11.767-77.989 110.145 43.15.224-61.785 99.9 75.951-9.691 14.375 38.356 67.447-25.65-14.537 100.299h88.508l-8.409-87.678 33.939 14.567 12.193-29.63 52.909 25.052 67.42-24.798-54.815-94.789z"/></svg>`,
};
